/**
 * GEO 雷达对外口径单源(修复波 0926 第五批 P1)。
 * - 耗时:演示机 0926 近 4 轮实测 257~285 秒 → 「约 4~5 分钟」;旧文案 ~2 分钟 / 约 10 分钟 / 约 1–2 分钟三处互相打架,已作废。
 * - 实测家数:search_probe 真联网只有通义千问、智谱 2 家,另外 6 家由实测结果推演;旧横幅「6 大模型联网实测」写错了。
 *   1007 扩到 4 家:+DeepSeek(百炼 enable_search)+豆包(方舟 web_search),推演剩文心/Kimi/元宝/纳米 4 家。
 * - 内容计划:报告是 4 周 × 每周 4 篇 = 16 篇;旧「6 个月 30 篇」与报告不一致。
 */
export const GEO_ETA_TEXT = "约 4~5 分钟";
export const GEO_PROBE_SCOPE_TEXT =
  "联网实测 4 家(通义千问、智谱、DeepSeek、豆包),另外 4 家按实测推演";
export const GEO_CONTENT_PLAN_TEXT = "4 周 × 4 篇 = 16 篇";
